import React, { useEffect, useState } from 'react';

import SidebarRun from './Sidebar.run';
import { Dropdown } from 'react-bootstrap'
import { Collapse, Badge } from 'reactstrap';

import USER_NO_PHOTO from './../../assets/user-no-photo.jpg'

export default function Menu() {
    const [collapse, setCollapse] = useState([])
    const [menu, setMenu] = useState([])
    const [changePassword, setChangePassword] = useState(false)
    const [dropDown, setDropDown] = useState(null)
    const [userName, setUserName] = useState('')
    const [urlPhoto, setUrlPhoto] = useState(USER_NO_PHOTO)

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            href="/#"
            ref={ref}
            className="mnp-name"
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
            <em className="open" style={{ fontSize: "14px", marginLeft: "10px" }}></em>
        </a>
    ));

    const SidebarItemHeader = ({ item }) => (
        <li className="nav-heading">
            <span>{item.heading}</span>
        </li>
    )

    const itemType = item => {
        if (item.heading) return 'heading';
        if (!item.submenu) return 'menu';
        if (item.submenu) return 'submenu';
    }

    const closeSidebar = () => {
        console.log('---')
        this.props.actions.toggleSetting('asideToggled');
    }

    const buildCollapseList = (Menu) => {
        let _collapse = {};

        Menu
            //.filter(({heading}) => !heading)
            .forEach(({ name, path, submenu }) => {
                _collapse[name] = routeActive(submenu ? submenu.map(({ path }) => path) : path)
            })

        setCollapse({ _collapse });
    }

    const routeActive = (paths) => {
        if (paths.length === 0)
            return false

        paths = Array.isArray(paths) ? paths : [paths];
        return paths.some(p => window.location.pathname.indexOf(p) > -1)
    }

    const SidebarSubItem = ({ item, isActive, handler, children, isOpen }) => (
        <li className={isActive ? 'active' : ''} style={{ padding: "10px" }}>
            <div className="nav-item" onClick={handler}>
                {item.label && <Badge tag="div" className="float-right ml-1" color={item.label.color}>{item.label.value}</Badge>}
                {item.icon && <em className={item.icon}></em>}
                <span className='ml-2'>{item.name}</span>
                <span className={isOpen ? 'arrow open' : 'arrow'}></span>
            </div>
            <Collapse isOpen={isOpen} >
                <ul id={item.path} className="sidebar-nav sidebar-subnav" >
                    {children}
                </ul>
            </Collapse>
        </li>
    )

    const SidebarSubHeader = ({ item }) => (
        <li className="sidebar-subnav-header">{item.name}</li>
    )

    const getSubRoutes = item => item.submenu.map(({ path }) => path)

    const SidebarItem = ({ item, isActive, collapse }) => (
        <li className={isActive ? 'active' : ''} >
            <a href={item.path} title={item.description} data-title={item.name}
                data-icon={item.icon}
                data-path={item.path}
                data-idmenu={item.idmenu} onClick={e => {
                    if (document.querySelector('body').classList.length > 0)
                        document.querySelector('body').classList = ''

                }}>
                {(!collapse) && <em className="arrow-right" style={{ fontSize: "14px" }}></em>}
                {item.label && <Badge tag="div" className="float-right" color={item.label.color}>{item.label.value}</Badge>}
                {(collapse) ? <em className={item.icon}></em> : ""}

                <span style={{ whiteSpace: "break-spaces" }}>{item.name}</span>
            </a>
        </li>
    )

    const toggleItemCollapse = (stateName) => {
        var _collapse = collapse;

        if (_collapse['_collapse'] !== undefined)
            _collapse = _collapse['_collapse'];

        for (let c in _collapse) {
            if (_collapse[c] === true && c !== stateName)
                _collapse[c] = false
        }

        _collapse[stateName] = !_collapse[stateName]
        setCollapse({ _collapse })
    }


    useEffect(() => {
        let _menus = [{
            "idmenu": 17,
            "name": "Agenda",
            "icon": "fa fa-calendar",
            "path": "/agenda",
            "description": "Agenda de Técnicos",
            "idparent": 1,
            "order": 1,
            "permission": 1,
            "idmodule": [
                0
            ]
        },
        {
            "idmenu": 18,
            "name": "SPM",
            "icon": "fa fa-desktop",
            "path": "/spm",
            "description": "Relatório de SPM",
            "idparent": 15,
            "order": 2,
            "permission": 2,
            "idmodule": [
                0
            ]
        },
        {
            "idmenu": 19,
            "name": "Integração",
            "icon": "fa fa-indent",
            "path": "/integracao",
            "description": "Integração",
            "idparent": 15,
            "order": 3,
            "permission": 2,
            "idmodule": [
                0
            ]
        },
        {
            "idmenu": 20,
            "name": "Estoque",
            "icon": "fa fa-server",
            "path": "/estoque",
            "description": "Contagens de Estoque",
            "idparent": 15,
            "order": 3,
            "permission": 2,
            "idmodule": [
                0
            ]
        },
        {
            "idmenu": 21,
            "name": "Atendimento",
            "icon": "fa fa-headset",
            "path": "/atendimento",
            "description": "Atendimento de OS",
            "idparent": 15,
            "order": 3,
            "permission": 2,
            "idmodule": [
                0
            ]
        },
        {
            "idmenu": 24,
            "name": "Dashboard de Vendas",
            "icon": "fa fa-chart-line",
            "path": "/vendas",
            "description": "Dashboard de Vendas",
            "idparent": 15,
            "order": 4,
            "permission": 2,
            "idmodule": [
                0
            ]
        },
        {
            "idmenu": 22,
            "name": "Conf. de Usuário",
            "icon": "fa fa-users-gear",
            "path": "/user-settings",
            "description": "Configurações de Usuários",
            "idparent": 15,
            "order": 5,
            "permission": 2,
            "idmodule": [
                0
            ]
        },
        {
            "idmenu": 23,
            "name": "Sair",
            "icon": "fa fa-door-closed",
            "path": "/logoff",
            "description": "Sair",
            "idparent": 15,
            "order": 6,
            "permission": 2,
            "idmodule": [
                0
            ]
        }
        ]

        buildCollapseList(_menus)
        setMenu(_menus)
    }, [])


    return (
        <aside className='aside-container'>
            <div className={`profile-wrap text-left`}>
                <div className="pad-btm">
                    <img alt="Foto do usuário" className="img-circle img-md" src={urlPhoto} />
                    {process.env.REACT_APP_ENABLED_CHAT === true ?
                        <span id="sp-user-status" className="circle circle-lg bg-success shadow-success" ></span>
                        : ""}
                </div>
                <div className="profile-desc">
                    <Dropdown title={userName}>
                        <Dropdown.Toggle as={CustomToggle} >
                            {userName}
                        </Dropdown.Toggle>
                        {dropDown ?
                            <Dropdown.Menu>
                                <Dropdown.Item href="#" onClick={e => setChangePassword(true)}><em className="fa fa-user-lock"></em> Mudar senha</Dropdown.Item>
                            </Dropdown.Menu>
                            : ""}
                    </Dropdown>
                </div>
                <span style={{ fontSize: "10px", color: "#fff", marginTop: "10px" }}>Versão: {process.env.REACT_APP_VERSION}</span>
            </div>
            <div className="aside-inner" id="page-sidebar-wrapper">
                <nav data-sidebar-anyclick-close="" className="sidebar">
                    <ul className="sidebar-nav">
                        {/* <div className='ml-1 mr-2 '> */}
                        {
                            menu.map((item, i) => {
                                // heading
                                if (itemType(item) === 'heading')
                                    return (
                                        <SidebarItemHeader item={item} key={i} />
                                    )
                                else {
                                    if (itemType(item) === 'menu')

                                        return (
                                            <SidebarItem isActive={routeActive(item.path)} item={item} key={i} collapse={true} />
                                        )
                                    if (itemType(item) === 'submenu')

                                        return [
                                            <SidebarSubItem item={item} isOpen={collapse['_collapse'][item.name]} handler={toggleItemCollapse.bind(this, item.name)} isActive={routeActive(getSubRoutes(item))} key={i}>
                                                <SidebarSubHeader item={item} key={i} />
                                                {
                                                    item.submenu.map((subitem, i) =>
                                                        <SidebarItem key={i} item={subitem} isActive={routeActive(subitem.path)} collapse={false} />
                                                    )
                                                }
                                            </SidebarSubItem>
                                        ]
                                }
                                return null; // unrecognized item
                            })

                        }
                        {/* </div> */}
                        {SidebarRun(closeSidebar)}
                    </ul>
                </nav>
            </div>

        </aside>
    );
}
